// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1oHY6","name":"ConsentHeader_name___yfq3","birthday":"ConsentHeader_birthday__2OKSf","skeleton":"ConsentHeader_skeleton__29aiH"};